import { Component, computed, effect, OnInit, signal, WritableSignal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService, BubdataCommonComponent, CommonDataModule, ComponentHeaderComponent, LipoMessageService, NovitaetenLookupService, NovitaetService, SettingsService, SortimentDtoClient, StoreCustomSetting } from 'FoxxyLib';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { filter, Observable, of, pipe, take } from 'rxjs';
import { VorschlagDetailStore } from './store/vorschlagDetailStore';
import { PanelModule } from 'primeng/panel';
import { CustomSetting, CustomSettingsModulEnum, CustomSettingsTypeEnum, IAuthUser, NoviColumn, NoviColumnBase, WupColumnType } from 'FoxxyInterfaces';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MandantService } from '../api/advsortiment/services';
import { ExtendedQueryTokenDTO } from '../api/advsortiment/models';

import { VorschlagDtoClient } from '../models/vorschlaege/vorschlagDTOClient';
import { VorschlagAbsatzDtoClient } from '../models/vorschlagAbsatzDtoClient';
import { TableModule } from 'primeng/table';
import { AbsatzPipe } from './pipes/Absatz#Pipe';
import { SplitterModule } from 'primeng/splitter';
import { FlexModelColumnData } from '../models/commondto/FlexColumnClientDto';

import { ToastMessageOptions } from 'primeng/api';
import { IftaLabelModule } from 'primeng/iftalabel';
import { GraphQlParam } from '../models/commondto/GraphQlParam';
import { gql_filialBestand } from './store/FilialBestandQuery';
import { Apollo } from 'apollo-angular';
import { GraphQLService } from '../graphql.service';
import { GraphQLModule } from '../graphql.module';
import { gql_weiterePlatzierungen } from './store/WeiterePlatzierungenQuery';





@Component({
  selector: 'app-vorschlagsdetails',
  standalone: true,

  imports: [MatIconModule, CommonModule, InputGroupModule, FormsModule, ComponentHeaderComponent, BubdataCommonComponent,
    InputTextModule, CommonDataModule,
    ToolbarModule, ButtonModule, PanelModule, FloatLabelModule, InputNumberModule, TableModule,
    ButtonModule, AbsatzPipe, SplitterModule, GraphQLModule,
    IftaLabelModule,
    InputGroupModule, InputGroupAddonModule
  ],
  providers: [VorschlagDetailStore, Apollo],
  templateUrl: './vorschlagsdetails.component.html',
  styleUrl: './vorschlagsdetails.component.scss'
})
export class VorschlagsdetailsComponent implements OnInit {

  ean: string;
  sortimentid: number;
  tagedelay: WritableSignal<number> = signal(7);
  selectcustomConfigs$: Observable<Array<CustomSetting<StoreCustomSetting>>> = of([]);
  config: CustomSetting<StoreCustomSetting>;
  authuser: IAuthUser;
  catalogProductNumber: string;

  fisColumns = [<NoviColumnBase>{ style: 'width: 2rem', field: 'absatzName', header: ' ' },
  <NoviColumnBase>{ style: 'width: 1.5rem; text-align: right;', field: 'fisMenge', header: 'FIS [Ex.]' },
  <NoviColumnBase>{ style: 'width: 1.5rem; text-align: right;', field: 'fisUmsatz', header: 'FIS [€]' },
  <NoviColumnBase>{ style: 'width: 1.5rem; text-align: right;', field: 'mcMenge', header: 'MC [Ex.]' },
  <NoviColumnBase>{ style: 'width: 1.5rem; text-align: right;', field: 'mcAnteil', header: 'MC-Anteil [%]' },
  ];
  fisAbsaetze: WritableSignal<Array<VorschlagAbsatzDtoClient>> = signal([]);

  platzierungsColumns = [];

  platzierungen: WritableSignal<Array<{ [key: string]: FlexModelColumnData }>> = signal([]);

  //nicht in diesem Sortiment
  weitereplatzierungsColumns = [];
  weitereplatzierungen: WritableSignal<any[]> = signal([]);
  hauptKategorie: WritableSignal<string> = signal(null);
  wkz: WritableSignal<string> = signal(null);

  constructor(private route: ActivatedRoute, private settingsServiee: SettingsService, private autUser: AuthService,
    private lipomessageService: LipoMessageService<ToastMessageOptions>,
    private graphqlservice: GraphQLService,
    private novitaetService: NovitaetenLookupService,
    private router: Router,
    public vorschlagstore: VorschlagDetailStore

  ) {
    this.selectcustomConfigs$ = this.settingsServiee.selectcustomConfigs$;


    effect(() => {
      const error = this.vorschlagstore.vorschlagError();
      if (error && error.message) {
        this.lipomessageService.Publish({ severity: 'error', summary: error.message, detail: error.userMessage });
      }
      const success = this.vorschlagstore.vorschlagSuccess();
      if (success && success.message) {
        this.lipomessageService.Publish({ severity: 'success', summary: success.message, detail: null });
        this.close();
      }
      const vorschlag = this.vorschlagstore.vorschlag();
      if (vorschlag) {
        this.createAbsatzPivot(vorschlag);
        this.createPlatzierungsDaten(vorschlag);
      }

      if (this.vorschlagstore.weitereplatzierungen())
      {
        this.weitereplatzierungen.set(this.vorschlagstore.weitereplatzierungen());
      }


    })

  }

  /**
   * weitere Platzierungen mit den hinzugefügten Vorschlägen
   */
  weitereplatzierungenComputed = computed(()=>
  {
      return this.weitereplatzierungen();
  })



  createPlatzierungsDaten(vorschlag: VorschlagDtoClient) {
    this.platzierungsColumns = [];
    this.platzierungsColumns.push(<NoviColumn>{ field: 'typ', header: '', width: 200, style: 'width: 12rem; min-width: 12rem !important;' });
    this.platzierungen.set([]);

    this.weitereplatzierungsColumns = [];
    this.weitereplatzierungsColumns.push(<NoviColumn>{ field: 'klammer_name', header: 'Klammer', width: 200, style: 'width: 12rem; min-width: 12rem !important;' });
    this.weitereplatzierungsColumns.push(<NoviColumn>{ field: 'sortiment_name', header: 'Sortiment', width: 200, style: 'width: 12rem; min-width: 12rem !important;' });
    this.weitereplatzierungen.set([]);



    if (vorschlag && vorschlag.sortimente && vorschlag.sortimente.length > 0) {
      const sortiment = vorschlag.sortimente[0];
      if (sortiment) {
        var platzierungzeile = new Array<{ [key: string]: FlexModelColumnData }>();
        const pVorschlag: { [key: string]: FlexModelColumnData } = {};
        const pAktuell: { [key: string]: FlexModelColumnData } = {};

        pVorschlag['typ'] = new FlexModelColumnData('typ', WupColumnType.Text, 'Vorschlag');
        pAktuell['typ'] = new FlexModelColumnData('typ', WupColumnType.Text, 'Aktuelle Platzierung');

        sortiment.module.forEach(m => {
          if (this.platzierungsColumns.find(f => f.field == m.modul) == undefined) {
            this.platzierungsColumns.push(<NoviColumn>{
              field: m.modul.toString(), header: 'M' + m.modul, width: 80, style: 'width: 80px'
            })
          }
          if (this.weitereplatzierungsColumns.find(f => f.field == m.modul) == undefined) {
            this.weitereplatzierungsColumns.push(<NoviColumn>{
              field: "platzierungen_moebel_name_" + m.modul.toString() , header: 'M' + m.modul, width: 80, style: 'width: 80px'
            })
          }
          pVorschlag[m.modul.toString()] = new FlexModelColumnData(m.modul.toString(), WupColumnType.Number, m.platzierungVorschlag?.platzierungsart);
          pAktuell[m.modul.toString()] = new FlexModelColumnData(m.modul.toString(), WupColumnType.Number, m.platzierungAktuell?.platzierungsart);

        })
        platzierungzeile.push(pVorschlag);
        platzierungzeile.push(pAktuell);

      }
      this.platzierungen.set(platzierungzeile);
    }
  }

  createAbsatzPivot(dto: VorschlagDtoClient) {

    this.fisAbsaetze.set([]);
    this.fisAbsaetze.set(dto.absaetze.sort((a, b) => {
      if (a.absatzName.toLowerCase() == 'gesamt') return -1;
      if (b.absatzName.toLowerCase() == 'gesamt') return -1;
      return a.absatzName.localeCompare(b.absatzName)
    }
    ).map(a => new VorschlagAbsatzDtoClient(a)));



  }

  canCancel = computed(() =>
    false
  );

  canClose = computed(() =>
    true
  );


  canSortimentieren = computed(() =>
    false
  );


  canZurueckstellen = computed(() =>
    true
  );


  canEntfernen = computed(() =>
    true
  );

  zurueckstellen() {
    const p = <MandantService.MandantDeferParams>
      {
        sortimentId: this.sortimentid,
        catalogProductNumber: this.catalogProductNumber,
        days: this.tagedelay()
      }
    this.vorschlagstore.vorschlagZurueckstellen(p);
  }

  entfernen() {

    const p = <MandantService.MandantRemoveParams>
      {
        sortimentId: this.sortimentid,
        catalogProductNumber: this.catalogProductNumber.toString()
      }
    this.vorschlagstore.vorschlagEntfernen(p);


  }


  sortimentieren() {
    this.router.navigate(['sortimentieren/detail/' + this.sortimentid + '/' + this.ean +'/soma']);
  }

  close() {
    window.history.back();
  }

  cancel() {
    window.history.back();
  }


  ngOnDestroy(): void {
  }

  ngOnInit(): void {

    // this.graphqlservice.preloadIntrospectiontypes(GraphQlEndpoint.Default);
    this.route.queryParams.pipe(filter(f => f && f.ean), take(1)).subscribe(params => {
      this.ean = params.ean;
      this.catalogProductNumber = params.catalogProductNumber;
      this.sortimentid = Number(params.sortimentId);
      const param = <MandantService.MandantQueryParams>{
        eagerLoading: 1,
        queryToken: <ExtendedQueryTokenDTO>{
          take: 0,
          skip: 0,
          input: {},
          filter: {
            "sortimente.sortimentid.=": this.sortimentid.toString(),
            "ean.equals": this.ean
          },
        }
      };

      this.vorschlagstore.getVorschlag(param);

      const par = <GraphQlParam>{}
      par.query = gql_filialBestand;
      par.variables = {
        skip: null, take: null, filter:
        {
          sortiment: { id: { eq: this.sortimentid } },
          artikel: { product: { ean: { value: { eq: this.ean } } } }
        }
      };
      par.operation = 'sortimentPlatzierung';
      this.vorschlagstore.GetFilialBestand(par)


      this.novitaetService.loadNovitaet(<NovitaetService.NovitaetQueryNovitaetenParams>{
        queryToken: <ExtendedQueryTokenDTO>{
        take: 1,
        skip: 0,
        input: {},
        filter: { "artikel.product.ean.equals":   this.ean.toString()
        },
        orderBy: [{ by: "id", desc: true }]
      },
        eagerLoading: 2
      })

      this.novitaetService.selectNovitaet$.pipe(filter(f=> f != undefined)).subscribe(f=> {
        this.hauptKategorie.set(f.hauptkategorie);
        this.wkz.set(f.marketing && f.marketing.vorschläge ? f.marketing.vorschläge.map(f=> f.text ).join(";") : null)
      })


      const parweitere = <GraphQlParam>{}
      parweitere.query = gql_weiterePlatzierungen;
      parweitere.variables = {
        skip: null, take: null, filter:
        {
          sortiment: { id: { neq: this.sortimentid } }, // not
          artikel: { product: { ean: { value: { eq: this.ean } } } }
        }
      };
      parweitere.operation = 'sortimentPlatzierung';
      this.vorschlagstore.getWeiterePlatzierungen(parweitere)



    })


    this.autUser.getLipoUser().subscribe(user => {
      this.authuser = user,
      this.settingsServiee.getCustomSettings(user.id, CustomSettingsModulEnum.GeneralSetting, CustomSettingsTypeEnum.CustomSetting);
    })

    this.selectcustomConfigs$.pipe(filter(f=> f != undefined && f.length > 0),take(1)).subscribe(configs => {
      this.config = configs.find(c => c.name == 'VorschlagTageDelay');
      if (this.config) {
        this.config = { ...this.config };
        this.config.data = JSON.parse(this.config.settingValue);
        if (this.config.data.strvalue) {
          this.tagedelay.set(Number(this.config.data.strvalue));
        }
      }
    })





  }


  tagedelayBlur(e) {
    if (this.config == undefined || this.config.id == null) {
      this.config = <CustomSetting<StoreCustomSetting>>{
        name: 'VorschlagTageDelay',
        userId: this.authuser.id,
        objectType: 'number',
        modul: CustomSettingsModulEnum.GeneralSetting,
        type: CustomSettingsTypeEnum.CustomSetting,
        data: <StoreCustomSetting>{
          strvalue: this.tagedelay().toString()
        }
      }
      this.config.settingValue = JSON.stringify(this.config.data);
      this.settingsServiee.insertCustomConfig(this.config);

    } else {
      this.config = { ...this.config };
      if (this.config.data == undefined) {
        this.config.data = JSON.parse(this.config.settingValue);
      }
      this.config.data.strvalue = this.tagedelay().toString();
      this.config.settingValue = JSON.stringify(this.config.data);
      this.settingsServiee.updateCustomConfig(this.config);
    }


  }


}
